import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { useTranslation } from "react-i18next";

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip role="tooltip" {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[10],
    fontSize: 9,
    maxWidth: 300,
    borderRadius: 0,
  },
}));

function ResultHeader() {

  const { t } = useTranslation();

  return (
      
      <div className='text-[9px] py-2 text-my-emerald bg-white flex w-full pl-12 lg:py-2 lg:border-b-[1px] border-b-[#e0e0e0] mb-[1px] pr-6 print:hidden'>
        <div className='hidden lg:block lg:w-1/2 xl:w-1/3'></div>
        <div className='hidden lg:flex lg:w-1/4 xl:w-1/6'>
          <p className='mr-[2px]'>{t('result.gradeserved')}&nbsp;
            <LightTooltip placement="right-end" title={t('result.gradeservedinfo')}>
              <sup className='text-[9px] w-2 cursor-pointer'><FontAwesomeIcon icon={faCircleInfo} /></sup>
            </LightTooltip>
          <br/>{t('result.feederschools')}</p>
        </div>
        <div className='hidden lg:flex lg:w-1/4 xl:w-1/12'>
          <p className='mr-[2px]'>{t('result.distance')}&nbsp;
            <LightTooltip placement="right-end" title={t('result.distancetimeinfo')}>
              <sup className='text-[9px] w-2 cursor-pointer'><FontAwesomeIcon icon={faCircleInfo} /></sup>
            </LightTooltip>
          <br/>{t('result.time')}</p>
        </div>
        <div className='hidden xl:flex xl:w-3/12'>
          <p>{t('result.metrorail')} <br/>
          {t('result.metrobus')}</p>
        </div> 
        <div className='hidden xl:flex w-1/6'>
          <p className='mr-[2px]'>{t('result.offeringmet')}</p>
          <LightTooltip  placement="right-end" title={t('result.offeringmetinfo')}>
            <sup className='text-[9px] w-2 cursor-pointer'><FontAwesomeIcon icon={faCircleInfo} /></sup>
          </LightTooltip>     
        </div>        
      </div>

  );

}


ResultHeader.propTypes = {};

ResultHeader.defaultProps = {};

export default ResultHeader;
